var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorInfo"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../assets/loading.gif"),"alt":"loading"}})]):_c('div',{staticClass:"authorWrapper"},[_c('div',{staticClass:"bar"},[_vm._v("作者")]),_c('div',{staticClass:"user"},[_c('router-link',{attrs:{"to":{
        name: 'user_info',
        params: {
          name: _vm.userInfo.loginname
        }
      }}},[_c('img',{attrs:{"src":_vm.userInfo.avatar_url,"alt":""}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.userInfo.loginname))])]),_c('p',[_vm._v("积分 "+_vm._s(_vm.userInfo.score))])],1)]),_c('div',{staticClass:"topics"},[_c('div',{staticClass:"bar"},[_vm._v("作者其他话题")]),_c('ul',_vm._l((_vm.userInfo.recent_topics),function(item,index){return (index <= 4)?_c('li',[_c('router-link',{attrs:{"to":{
          name: 'post_content',
          params: {
            id: item.id,
            name: item.author.loginname
          }
        }}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1):_vm._e()}))]),_c('div',{staticClass:"replies"},[_c('div',{staticClass:"bar"},[_vm._v("作者最近回复")]),_c('ul',_vm._l((_vm.userInfo.recent_replies),function(item){return _c('li',[_c('router-link',{attrs:{"to":{
          name: 'post_content',
          params:{
            id: item.id,
            name: item.author.loginname
          }
        }}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)}))])])}
var staticRenderFns = []

export { render, staticRenderFns }